<template>
  <b-modal 
    ref="modal" 
  >
    <template #modal-title>
      {{$t('driver.fetch.title')}} {{ barcode }}
    </template>

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-else>

      <template v-if="!shipment">
        <form-input 
          label="shipments.merchant" 
          icon="bx-cart"
          type="item"
          :scope="[['feature', FEATURE_FETCHING]]"
          v-model="merchant_id"
          resource-name="merchants"
          :clearable="false"
        />
      </template>

      <template v-else>
        <b-alert show variant="warning">
          {{$t('driver.fetch.not-intended', { name: shipment.$meta.title })}}
        </b-alert>
        <form-input
            type="item" 
            label="driver.fetch.select-dropoff-location" 
            icon="bx-map"
            v-model="shipment.dropoff_location_id"
            resource-name="locations"
            :scope="[['dropoff',shipment.merchant_id]]"
          />
      </template>

    </div>

    <template #modal-footer>
      <b-button @click="close(false)">
        {{$t('common.cancel')}}
      </b-button>
      <b-button v-if="merchant_id && !shipment" @click="fetch" variant="primary">
        <i class='bx bx-import' ></i>
        {{$t('driver.fetch.fetch-button')}}
      </b-button>
      <b-button v-if="shipment" :disabled="!shipment.dropoff_location_id" @click="save" variant="primary">
        <i class='bx bx-save' ></i>
        {{$t('item.save')}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import Modal from "@/components/Modal"
import { mapGetters } from 'vuex'
import FormInput from "@/components/Form/Input";
import { FEATURE_FETCHING } from "@/resources/Merchant";
import api from "@/api";
import Shipment, { STATUS_AWAITING_PICKUP } from "@/resources/Shipment";

export default {
  name: 'FetchPackage',
  components: {FormInput},
  extends: Modal,
  data() {
    return {
      FEATURE_FETCHING,
      loading: false,
      merchant_id: null,
      shipment: null,
    }
  },
  props: {
    barcode: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    async fetch() {
      this.loading = true

      try {
        const { data } = await api.get(`driver/fetch-package`,{
          params: {
            barcode: this.barcode,
            merchant_id: this.merchant_id,
          }, 
        })

        this.shipment = new Shipment(data.data, data.meta)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }

      if(this.shipment.status == STATUS_AWAITING_PICKUP) {
        this.close(this.barcode)
      }
    },
    async save() {
      this.loading = true

      try {
        await api.put(`driver/fetch-set-location/${this.shipment.id}`, {
          location_id: this.shipment.dropoff_location_id
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }

      this.close(this.barcode)
    }
  }
}
</script>